export default __webpack_public_path__ + "static/media/voltlines@logo.4dddba5c.png";